module.exports = __webpack_public_path__ + "img/insert-1.a5681aea.png";